import { createGlobalStyle } from "styled-components";

const DARK_COLOR = "#282828"

export const DarkmodeStyle = createGlobalStyle`
  body[data-theme="dark"] {
    .ant-collapse {
      border-color: ${DARK_COLOR};

      .ant-collapse-item {
        border-color: ${DARK_COLOR};

        .ant-collapse-header {
          color: #fff;
        }
      }
    }
  }
`
